import { render } from "./AboutComp.vue?vue&type=template&id=f2d3cd92&scoped=true"
import script from "./AboutComp.vue?vue&type=script&lang=js"
export * from "./AboutComp.vue?vue&type=script&lang=js"

import "./AboutComp.vue?vue&type=style&index=0&id=f2d3cd92&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d3cd92"]])

export default __exports__